import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.19297 4.69231C9.91406 4.69231 10.818 4.20407 11.3562 3.55308C11.8438 2.96313 12.1992 2.13922 12.1992 1.31532C12.1992 1.20343 12.1891 1.09154 12.1687 1C11.3664 1.03051 10.4016 1.5391 9.82266 2.2206C9.36562 2.73935 8.94922 3.55308 8.94922 4.38716C8.94922 4.50922 8.96953 4.63128 8.97969 4.67196C9.03047 4.68214 9.11172 4.69231 9.19297 4.69231ZM6.65391 17C7.63906 17 8.07578 16.3388 9.30469 16.3388C10.5539 16.3388 10.8281 16.9797 11.925 16.9797C13.0016 16.9797 13.7227 15.9828 14.4031 15.0064C15.1648 13.8875 15.4797 12.7889 15.5 12.7381C15.4289 12.7177 13.3672 11.8735 13.3672 9.5035C13.3672 7.44882 14.9922 6.5232 15.0836 6.452C14.007 4.90591 12.3719 4.86523 11.925 4.86523C10.7164 4.86523 9.73125 5.59758 9.11172 5.59758C8.44141 5.59758 7.55781 4.90591 6.51172 4.90591C4.52109 4.90591 2.5 6.55372 2.5 9.66624C2.5 11.5989 3.25156 13.6434 4.17578 14.9657C4.96797 16.0846 5.65859 17 6.65391 17Z",
      fill: "black"
    }, null, -1)
  ]))]))
}
export default { render: render }